import { render, staticRenderFns } from "./DeleteRegionSeoDialog.vue?vue&type=template&id=49c53041&"
import script from "./DeleteRegionSeoDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteRegionSeoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports